import getSelectors from '@elab/core/utils/dynaForms/selectors';

import { storeName } from './types';

const getState = state => state[storeName] || {};
const getRecords = state => getState(state).records;
const getFurtherAvailabilityState = state => getState(state).hasMoreEntries;
const getPageSize = state => getState(state).pageSize;
const getPageNumber = state => getState(state).pageNumber || 0;
const getRequestedPageNumber = state => getPageNumber(state) + 1;

export default {
    ...getSelectors(storeName),
    getRecords,
    getFurtherAvailabilityState,
    getPageSize,
    getPageNumber,
    getRequestedPageNumber,
};
